const templateSelect = document.getElementById('templateId');
const headingInput = document.getElementById('HeadingSv');
const mainBodyInput = document.getElementById('MainBodySv');

const headingInputEn = document.getElementById('HeadingEn');
const mainBodyInputEn = document.getElementById('MainBodyEn');


const templateChanged = async () => {
    if (templateSelect.value != '') {
        var res = await fetch("./TemplateData?templateId=" + templateSelect.value, { method: "POST" });
        var data = await res.json();
        headingInput.value = data.heading;
        tinymce.get("MainBodySv").setContent(data.body);

        headingInputEn.value = data.headingEn;
        tinymce.get("MainBodyEn").setContent(data.bodyEn);

        tinymce.get("MainBodySv")

        tinymce.get("MainBodyEn")
    }
    else {
        tinymce.get("MainBodySv")

        tinymce.get("MainBodyEn")
    }
};

templateSelect.addEventListener('change', templateChanged)
import '../../../static/js/loaders/tinymce';